(function () {
    'use strict';

    function requestForProposalDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/';

        function loadRequestForProposal(id) {
            return $http.get(baseUrl + id).then(function (response) {
                return response.data;
            });
        };

        function saveRequestForProposal(data) {
            return $http.put(baseUrl + data.Id, data).then(
                function (response) { return true; }
            );
        };

        function deleteUploadBlob(blobReference) {
            return $http.get('/Files/DeleteUploadBlob?blobReference=' + blobReference).then(
                function (response) { return response.data; });
        };


        function deleteRequestForProposal(id) {
            return $http.delete(baseUrl + id).then(function (response) {
                return response.data;
            });
        }

        return {
            loadRequestForProposal: loadRequestForProposal,
            saveRequestForProposal: saveRequestForProposal,
            deleteUploadBlob: deleteUploadBlob,
            deleteRequestForProposal: deleteRequestForProposal
        }
    }

    requestForProposalDataService.$inject = ['$http'];

    angular.module('ecap.common').service('requestForProposalDataService', requestForProposalDataService);
})();
